'use strict';
angular.module('issuedByForceModule', []).controller('issuedByForceCtrl', ['$scope', '$state', '$modalInstance', 'modalDialog', 'options', 'trsHttpService', 'editingCenterService',
    function($scope, $state, $modalInstance, modalDialog, options, trsHttpService, editingCenterService) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {};
            $scope.data = {
                items: options.items,
                selectedArray: [],
                from: $state.current.name.split('.')[2]
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            $scope.data.isShowColumn = $scope.data.from === 'newspaper' || $scope.data.from === 'website' || $scope.data.from === 'app';
        }

        /**
         * [selectDoc description] 选中稿件
         * @param  {[type]} item [description] 稿件信息
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index >= 0) {
                $scope.data.selectedArray.splice(index, 1);
            } else {
                $scope.data.selectedArray.push(item);
            }
        };

        /**
         * [selectAll description] 选中稿件
         * @param  {[type]} item [description] 稿件信息
         * @return {[type]}      [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.items.length ? [] : $scope.data.items;
        };

        /**
         * [confirm description] 确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            // var chnldocIDs = $scope.data.selectedArray.map(function(value, index) {
            //     return value.DOC.CHNLDOCID;
            // }).join(',');
            // var metadataIds = $scope.data.selectedArray.map(function(value, index) {
            //     return value.DOC.METADATAID;
            // }).join(',');
            // if (!options.serviceid || !options.serviceid) {
            //     return;
            // }
            // var params = {
            //     serviceid: options.serviceid,
            //     methodname: options.methodname,
            //     ObjectIds: chnldocIDs,
            //     ChnlDocIds: chnldocIDs,
            //     MetaDataIds: metadataIds,
            //     enforcement: '1'
            // };
            options.callback && options.callback(options.params, $scope.data.selectedArray);
            options.params.enforcement = '1';
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), options.params, 'get').then(function(data) {
                // modalDialog.alertType('签发成功', '', 'success', false, function() {
                //     $modalInstance.close();
                // });
                // if (options.noAlert) {
                //     $modalInstance.close('success');
                //     return;
                // }
                // modalDialog.multiReportsAlert(data);
                $modalInstance.close(data);
            });
            // $modalInstance.close($scope.data.selectedArray);
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.close(false);
        };

        $scope.toPreview = function(item) {
            editingCenterService.routerToPreview(item);
        };
    }
]);
